"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/*
	intro : event pub/sub based on personal event defination
	Author : chenchao
	Date : 2019-06-17
	Note : only can handle named function
*/


var _reactPureCheck = require("react-pure-check");

var _log = require("./log");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SingleEventFun = function () {
  function SingleEventFun(eventName) {
    _classCallCheck(this, SingleEventFun);

    this.eventName = eventName;
    this.event = null;
    this.eventArr = [];
    this.eventNameArr = []; // Single Pattern
  } // create event (saved)


  _createClass(SingleEventFun, [{
    key: "createEvent",
    value: function createEvent(eventName) {
      // has registed this event name
      if ((0, _reactPureCheck.Types)(this.event) !== "null") {
        return this.event;
      } // has not registed this event name


      var doc = window.document || {};
      this.event = doc.createEvent('Event');
      this.event.initEvent(eventName, false, false);
    } // get unique num 

  }, {
    key: "getUniqueNum",
    value: function getUniqueNum() {
      return Math.random().toString(36).slice(2);
    } // on event callback

  }, {
    key: "on",
    value: function on() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      if ((0, _reactPureCheck.Types)(callback) !== "function") {
        (0, _log.errorBreak)("you should offer a %s for on callback", "function");
      } // TODO 
      // add unique name


      callback.uniqueNum = this.getUniqueNum();

      if (callback.name) {
        this.eventNameArr.push(callback.name);
        this.eventArr.push(callback);
      }
    } // remove one callback

  }, {
    key: "remove",
    value: function remove() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      if (!callback.name) {
        (0, _log.errorBreak)("remove can only remove a named callback");
        return false;
      }

      var index = this.eventNameArr.indexOf(callback.name);

      if (index >= 0) {
        this.eventNameArr.splice(index, 1);
        this.eventArr.splice(index, 1);
      }
    } // remove all callback

  }, {
    key: "removeAll",
    value: function removeAll() {
      this.eventArr = [];
      this.eventNameArr = [];
    } // emit
    // @overload -  catch overload data

  }, {
    key: "emit",
    value: function emit() {
      var overload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.eventArr.map(function (item, index) {
        if ((0, _reactPureCheck.Types)(item) === "function") item(overload);
      });
    }
  }]);

  return SingleEventFun;
}();

; // evnet function

var SingleEvent = function SingleEvent(eventName) {
  if ((0, _reactPureCheck.Types)(eventName) !== "string") {
    (0, _log.errorBreak)("please offer a %s ", "eventName");
  }

  return new SingleEventFun(eventName);
};

exports.default = SingleEvent;